import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type InterfaceDeleteModalAction = "confirm" | "cancel";

export function useEmitInterfaceDeleteModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: InterfaceDeleteModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.InterfaceDeleteModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
